export const LEAD_STATUSES = [
  { value: "new_lead", label: "New Lead", color: "bg-sky-50 text-sky-700 border-sky-200" },
  { value: "interested", label: "Interested", color: "bg-indigo-50 text-indigo-700 border-indigo-200" },
  { value: "qualified", label: "Qualified", color: "bg-violet-50 text-violet-700 border-violet-200" },
  { value: "sample_sent", label: "Sample Sent", color: "bg-amber-50 text-amber-700 border-amber-200" },
  { value: "customer", label: "Customer", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  { value: "repeat_customer", label: "Repeat Customer", color: "bg-emerald-100 text-emerald-800 border-emerald-300" },
  { value: "lost", label: "Lost", color: "bg-red-50 text-red-700 border-red-200" },
];

export const statusByValue = (v) => LEAD_STATUSES.find((s) => s.value === v) || LEAD_STATUSES[0];

export const TIMELINE_ICONS = {
  contact_created: "user-plus",
  contact_updated: "edit-3",
  tag_added: "tag",
  tag_removed: "tag",
  broadcast_sent: "send",
  broadcast_delivered: "check-circle",
  broadcast_read: "eye",
  message_sent: "message-square",
  message_received: "message-circle",
  flow_started: "zap",
  flow_completed: "check-circle-2",
  note_added: "file-text",
};
